import { IStore } from 'store/types';

export const selectIsLoadingAPIRequest = (state: IStore, action: string) => {
  const request = state.api.requests[action.replace('_REQUEST', '')];
  return request?.isLoading;
};

export const selectAPIRequestErrors = (state: IStore, actionType: string) => {
  const request = state.api.requests[actionType.replace('_REQUEST', '')];
  return request?.errors;
};

export const selectAPIRequestStatus = (state: IStore, action: string) => {
  const request = state.api.requests[action.replace('_REQUEST', '')];
  return request?.status;
};
